import { RestClient } from "..";

export type B000201FindRequest = Partial<{
  janCdFrom: string;
  janCdTo: string;
  kensu: string;
}>;

export type B000201FindResponse = {
  janKouho: string;
};

export const B000201Find = (props: B000201FindRequest) => {
  return RestClient.get<B000201FindResponse[]>("b000201/find", {
    params: props,
  });
};
